import { beHttp } from './beHttp';

/**
 * Estado del lanzamiento de Comunidad (pop-up único "Novedad: Comunidad" + badge "Nuevo" de
 * la pestaña) — vive en psiplatform-be, no en api-core. Ver
 * psiplatform-be/src/modules/comunidad/comunidad-launch.*
 */
export interface ComunidadLaunchState {
  /** Cerró con la X o apretó "Quiero saber más": el pop-up no vuelve a salir. */
  dismissed: boolean;
  /** ISO del fin de la posposición vigente; null si no hay. */
  snoozedUntil: string | null;
  /** Ya entró alguna vez a Comunidad — el badge "Nuevo" se apaga. */
  visited: boolean;
}

/** Lo que devuelve el GET: el estado más si el aviso le corresponde a esta psicóloga. */
export interface ComunidadLaunchReadState extends ComunidadLaunchState {
  /** false si la ventana del lanzamiento cerró o se dio de alta después del lanzamiento —
   *  el pop-up y el badge "Nuevo" no se muestran. */
  eligible: boolean;
}

const BASE_PATH = '/api/comunidad/launch';

export async function getComunidadLaunchState(): Promise<ComunidadLaunchReadState> {
  return beHttp.get<ComunidadLaunchReadState>(BASE_PATH, undefined, { showErrorToast: false });
}

export async function dismissComunidadLaunch(): Promise<ComunidadLaunchState> {
  return beHttp.post<ComunidadLaunchState>(`${BASE_PATH}/dismiss`, undefined, { showErrorToast: false });
}

export async function snoozeComunidadLaunch(): Promise<ComunidadLaunchState> {
  return beHttp.post<ComunidadLaunchState>(`${BASE_PATH}/snooze`, undefined, { showErrorToast: false });
}

export async function markComunidadVisited(): Promise<ComunidadLaunchState> {
  return beHttp.post<ComunidadLaunchState>(`${BASE_PATH}/visited`, undefined, { showErrorToast: false });
}
